import { createAction } from '@reduxjs/toolkit';

export const ON_DISCONNECT_ACTION_TYPE = 'saga/onDisconnect';
export const onDisconnectAction = createAction(ON_DISCONNECT_ACTION_TYPE);
